import styled from "styled-components";
import React from 'react';

const CheckboxWrapper = styled.div`
    position: relative;
`;

const CheckboxLabel = styled.label`
        cursor: pointer;
        font-weight: normal;
        &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 1px;
            width: 16px;
            height: 16px;
            margin-top: 0px;
            background: #F6F7F7;
            border: 1px solid rgba(0, 0, 0, 0.54);
            border-radius: 2px;
            cursor: pointer;
            transition: background .3s;

        }
        &::after {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
        }
`;

const CheckboxInput = styled.input`
        outline: 0;
        margin-right: 16px !important;
        visibility: hidden;
        &:checked + ${CheckboxLabel}::before {
            background: #0079AC;
            border: none;
            width: 18px;
            height: 18px;
        }
        &:checked + ${CheckboxLabel}::after {
            transform: rotate(-45deg);
            top: 5px;
            left: 3px;
            width: 11px;
            height: 5px;
            border: 2px solid #fff;
            border-top-style: none;
            border-right-style: none;
        }
        &:indeterminate + ${CheckboxLabel}::before {
            background: #0079AC;
            border: none;
            width: 18px;
            height: 18px;
        }
        &:indeterminate + ${CheckboxLabel}::after {
            top:9px;
            left: 3px;
            width: 11px;
            height: 0px;
            border: 2px solid #fff;
            border-top-style: none;
            border-right-style: none;
        }
`;


class Checkbox extends React.Component {

    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
    }

    render() {
        if (this.inputRef.current) {
            this.inputRef.current.indeterminate = this.props.indeterminate;
        }

        return (<CheckboxWrapper>
            <CheckboxInput onChange={(i) => { this.props.handleClick(!this.props.checked) }} checked={this.props.checked} type="checkbox" ref={this.inputRef} />
            <CheckboxLabel onClick={(e) => { e.stopPropagation(); this.props.handleClick(!this.props.checked) }} ></CheckboxLabel>
        </CheckboxWrapper>)
    }
}

export default Checkbox;